import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-caderneta',
    templateUrl: './caderneta.component.html',
    styleUrls: ['./caderneta.component.scss']
})
export class CadernetaComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
